<template>
    <v-dialog v-model="$store.getters.publisherInfoDialog" persistent max-width="1100" hide-overlay >
        <v-card>

            <v-card-title class="mb-3 headline secondary primary--text">
                <v-row>
                    <v-col cols="3">
                        <h6>Πληροφορίες εκδότη:</h6>
                    </v-col>
                    <v-col cols="8">
                        <v-chip outlined color="primary">{{publisher.publisherName}}</v-chip>
                    </v-col>
                    <v-col cols="1">
                        <v-icon color="primary" @click="closeDialog">close</v-icon>
                    </v-col>
                </v-row>


            </v-card-title>

            <v-card-text style="background-color: #BDC9D2">
                <v-row justify="center">
                    <v-col cols="6">
                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Διακριτικός Τίτλος </v-list-item-title>
                                <v-list-item-subtitle>{{publisher.publisherTradeName}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Τηλέφωνο (Σταθερό)	 </v-list-item-title>
                                <v-list-item-subtitle>{{publisher.publisherPhone}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Τηλέφωνο (Κινητό)	 </v-list-item-title>
                                <v-list-item-subtitle>{{publisher.publisherMobilePhone}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Fax </v-list-item-title>
                                <v-list-item-subtitle>{{publisher.publisherFax}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Email </v-list-item-title>
                                <v-list-item-subtitle>{{publisher.publisherEmail}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Ιστοσελίδα </v-list-item-title>
                                <v-list-item-subtitle><a style="color: darkslategrey" :href=publisher.publisherURL target="_blank">
                                    {{publisher.publisherURL}}</a></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title >Διεύθυνση </v-list-item-title>
                                <v-list-item-subtitle>{{publisher.publisherAddress}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>

                    <v-col cols="6">
                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > ΤΚ </v-list-item-title>
                                <v-list-item-subtitle>{{publisher.publisherZipCode}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Πόλη</v-list-item-title>
                                <v-list-item-subtitle>{{publisher.cityName}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Νομός</v-list-item-title>
                                <v-list-item-subtitle>{{publisher.prefectureName}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Υπεύθυνος για το Εύδοξος</v-list-item-title>
                                <v-list-item-subtitle>{{publisher.contactName}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Τηλέφωνο υπεύθυνου για το Εύδοξος</v-list-item-title>
                                <v-list-item-subtitle>{{publisher.contactPhone}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Κινητό τηλέφωνο υπεύθυνου για το Εύδοξος</v-list-item-title>
                                <v-list-item-subtitle>{{publisher.contactMobilePhone}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item >
                            <v-list-item-content>
                                <v-list-item-title > Email υπεύθυνου για το Εύδοξος</v-list-item-title>
                                <v-list-item-subtitle>{{publisher.contactEmail}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>


                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>
	export default {
		name: "PublisherInfoDialog",
        data: () => ({
		}),

		props: {
			publisher: Object
		},

		methods: {
			closeDialog(){
                this.$store.commit('setPublisherInfoDialog', false);
            },
		},
	}
</script>

<style scoped>

</style>